import { Component, OnInit,Output, EventEmitter, AfterViewInit, Injectable } from '@angular/core';
import { InstiService } from './insti.service';
import { InstiModalService } from './insti-modal.service';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl
} from '@angular/forms';
import { ActivatedRoute, Router, NavigationStart } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CustomValidators } from 'ng2-validation';
import { LocalDataSource } from 'ng2-smart-table';
import { instiRoutehandle } from './instiRoutehandle.module';
import {NgbModal, NgbModalOptions, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {InstiHelpers} from './instihelpers.module';
//import Swal from 'sweetalert2';
import {instiLoading} from './instiLoading.module';
declare var $;
export const insti_helpers=new InstiHelpers();

export const modal_service=null; //new InstiModalService(new NgbModal());
//export let app_injector: Injector;
/*
@Component({
  selector: 'app-insti',
  styleUrls: ['./insticss.component.css']
})
*/
export class InstiComponent implements OnInit, AfterViewInit {
   /**
   * ==============================================
   * DECLARATIONS
   * ==============================================
   */
  public form: FormGroup;
  public model: any;
  private list_on_start=true;
  protected page_title:string; //::Texto que será Exibido no topo da página
  protected add_link:string; //::Caminho da pagina de formulario;
  protected add_label:string; //::Texto exibido no botão adicionar novo;
  protected matrix:any;
  protected table_source_data: LocalDataSource;
  protected table_settings:any; /*:: Settings da smart-table */
  protected form_builder: FormBuilder;
  protected permissoes_dados;
  protected showExportButton:boolean = true;
  public dta_conv;
  load_tela: boolean = true;
  btn_esconder: boolean = true;
  public label_campos_controle = "Campos de Auditoria";
  @Output() is_loading: EventEmitter<any> = new EventEmitter();
  loadObj: instiLoading;
  public altura_tabela = "330px";
  /**
   * @VARIABLE page_mode =['list, add, edit, del]
   */
  private page_mode:string ='list';
  private page_modes_allows :Array<string>  =['list', 'add', 'edit', 'del', 'view'];
  protected dialog: MatDialog;
  private modal_instance:any;
  anexo;
  file = undefined;
  public helpers:any=insti_helpers;
  protected array_imprimir: string;
  public cod_tela:string;
  token;
  url_export = '';



  constructor(
              protected insti_route?:instiRoutehandle,
              protected service?: InstiService,
              protected location?: Location,
              protected modalService?:NgbModal,
              protected local_service?:InstiService
            )
   {
           this.setModalServiceInstance(modalService);
           this.setup();
   }
  /**
   * ==============================================
   * GETTERS
   * ==============================================
   */
  public getTableSourcedata(){ return this.table_source_data; }
  public getModel(){ return this.model;}
  public getForm(){ return this.form;}
  public getPageModesAllows(){ return this.page_modes_allows;}
  public getPageMode(){ return this.page_mode;}
  public getPageModeList(){ return 'list';}
  public getPageModeAdd(){ return 'add';}
  public getPageModeEdit(){ return 'edit';}
  public getPageModeDel(){ return 'del';}
  public getPageModeView(){ return 'view';}
  public isPageMode(modo:string):boolean{ return this.getPageMode() == modo.toLowerCase();}
  public getListOnStart(){ return this.list_on_start;}
  public getPageTitle(){ return this.page_title;}
  public getAddLink(){ return this.add_link;}
  public getAddLabel(){ return this.add_label;}
  public getCodTela(){ return this.cod_tela;}
  public getFormBuilder(){ return this.form_builder;}
  public isLockForm():boolean{ return !this.isPageMode(this.getPageModeAdd()) && !this.isPageMode(this.getPageModeEdit())}
  /**
   * @author Matheus Lopes Correia
   * @return boolean
   */
  public isLockCod():boolean{return !this.isPageMode(this.getPageModeEdit()) }
  public getModalService(){ return this.modal_instance; }
  public getService(){ return this.service;}
  public getHelpers(){ return this.helpers;}

  /**
   * ==============================================
   * SETTERS
   * ==============================================
   */
   /**
   * Utilizado na pagina de form
   */
  public setDateEngToBr(campo_date){
      let dados = this.insti_route.getParams();

      var data= dados[campo_date];

    // return data;
      var dt=new Date(data);


      return dt;
  }
  /*
  *   Metodo usado quando o campo salario possui decimal(18,5)
  */
  public setSalario(campo_salario,atrib_id?,op?){

    let dados = this.insti_route.getParams();
    if(dados[campo_salario]==null){
      return 0;
    }
    else{
      if(op){
        if(!this.isPageMode(this.getPageModeAdd())){
          var sem_mask=document.getElementById(atrib_id);
          sem_mask.removeAttribute("mask");
        }
      }

      var salario=dados[campo_salario].toString();
      var salario_=salario.toString();

        if(salario_.lastIndexOf("0",0)){
          var sal=salario_.substring(0,(salario_.length - 1)).replace(".",",");
          return sal;
        }
        else{
          return salario_.replace(".",",");
        }
    }
  }
  /*
  *   Metodo usado quando o campo salario possui decimal(18,2)
  */
 public salDecAdd(value,id_comp?){
  if(id_comp!=null){
    var mascara=document.getElementById(id_comp);
    mascara.removeAttribute("mask");
  }

  var salario=value;
  if(salario==undefined){
    console.log("Salario undefined");
  }else{

    var sal_max=salario.replace(".",",");

    return sal_max;
  }
}

  public setSalDec(value,id_comp?){

    let dados = this.insti_route.getParams();
    var mascara=document.getElementById(id_comp);
    mascara.removeAttribute("mask");

    var salario=dados[value];
    if(salario==undefined){
    }else{

      var sal_max=salario.replace(".",",");

      return sal_max;
    }
  }
  protected setModel(value):InstiComponent{
    this.model=value;
    return this;
  }
  protected setPageMode(value:string):InstiComponent{
      this.page_mode=this.getPageModesAllows().indexOf(value)>-1? value : 'list';
      return this;
  }
  protected setMatrix(valores):InstiComponent{
     var instance=this;
     instance.matrix=valores;
     return this;
  }
   protected setTableSourcedata(value:LocalDataSource){
        this.table_source_data=value;
        return this;
   }
  protected setFormBuilder():InstiComponent{
    this.form_builder=new FormBuilder();
    return this;
  }
  protected setForm(value:any):InstiComponent{
      this.form=this.getFormBuilder().group(value);
      return this;
  }
  protected setListOnStart(value:boolean):InstiComponent{
      this.list_on_start=value;
      return this;

  }
  protected setPageTitle(value:string):InstiComponent{
      this.page_title=value;
      return this;
  }
  protected setAddLink(value:string):InstiComponent{
    this.add_link=value;
     return this;
  }
  protected setAddLabel(value:string):InstiComponent{
      this.add_label=value;
      return this;
  }
  protected setCodTela(value:string):InstiComponent{
    this.cod_tela = value;
    return this;
  }
  protected setModePageFromParams():InstiComponent{
    this.setPageMode(this.getModoFromParams());
    return this;
  }
  protected setModalServiceInstance(value){
      this.modal_instance=new InstiModalService(value);
  }
  /***
   * =========================================================
   * PRIVATES GENERAL
   * =========================================================
   */
   protected extractDataFromEvent(event){
       return (!event? {}: event).hasOwnProperty('data') ? event.data: {};
   }


  /**
   * ==============================================
   *  GENERAL
   * ==============================================
   */
    ngOnInit() {
      this.getItemToken();
      this.formAndModelPopulateFromUrlParam();

      //Router.getCurrentNavigation().extras.state
    }
    ngAfterViewInit(value=false){
       if(!this.isListOnStart()){

          this.setIsLoading(value);
          return this;
      }
      setTimeout(() => {
        this.listarOnStart();
      })

       return this;
    }

  protected tableSourceData(){

  }
  public isListOnStart():boolean{ return this.getListOnStart()===true;}
  public loadScript(url){
    let node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(node);
  }
  public getModoFromParams(){ return this.insti_route.getParams('modo'); }

 protected setup():InstiComponent{
  this.initLoadObj();
      return this.setTableSourcedata(new LocalDataSource())
          .setFormBuilder();
  }
  protected listarOnStart(){
    var instance=this;
      instance.setIsLoading(true);
      this.getService().listar(instance.getTableSourcedata(), function(){
        instance.setIsLoading(false);
      }, null);
      return this;
  }
  protected gotoAddForm(){
      var url_destination=this.getAddLink();
      var dados={modo: this.getPageModeAdd()};
      this.insti_route.getRoutObj().navigate([url_destination], {queryParams:dados});
  }
  protected gotoEditForm(event){
      var dados=this.extractDataFromEvent(event);
      var url_destination=this.getAddLink();

      dados.modo=this.getPageModeEdit();
      this.setPageMode(this.getPageModeEdit());

     this.insti_route.getRoutObj().navigate([url_destination], {queryParams:dados});
  }
  protected gotoDeletForm(event){
      var dados=this.extractDataFromEvent(event);
      var url_destination=this.getAddLink();

      dados.modo=this.getPageModeDel();

      this.insti_route.getRoutObj().navigate([url_destination], {queryParams:dados});
  }
  protected getFormValues(form?){
       var form_data=!form ? this.getForm() : form ;

      return form_data.hasOwnProperty('value') ? form_data.value: {};
  }
  protected sendForm(call_error?){
      var form_data=this.getFormValues();
      let instance = this;
    this.getService().setPageUrlBase(this.getService().getPageUrlBase());

      if(this.isPageMode(this.getPageModeEdit())){
          this.onEditConfirm(form_data);

      }

      if(this.isPageMode(this.getPageModeDel())){
        this.onDeleteConfirm(form_data);

      }

      if(this.isPageMode(this.getPageModeAdd())){
        instance.setIsLoading(true);
        this.getService().adicionar(form_data,
            function(response){
              instance.setIsLoading(false);
                instance.showAlert('Sucesso', response['msg'], 'success');
                instance.formClean();
                instance.goBackSmsg();
                //  window.alert('Deu certo. COD:110920190925.');
            } ,
            function(error){
              instance.setIsLoading(false);
                instance.showAlert('Erro', error.error.msg, 'error');
                if(call_error && (typeof call_error) === 'function'){
                  return call_error(false);
                }
                return true;
                //  window.alert('Deu erro. COD: 10920190924');
        });
      }
  }
  protected formAndModelPopulateFromUrlParam(){
      if(this.setModePageFromParams()
            .isPageMode(this.getPageModeList())===false){
              this.modelPopulate(this.insti_route.getParams())
              .formPopulate(this.insti_route.getParams());
       }
       return this;
  }

  protected formPopulate(values, form_instance?):InstiComponent{
    var form=!form_instance? this.getForm() : form_instance;
    var controls=!form? {} : (form.hasOwnProperty('controls') ? form.controls : {});
    var chaves=Object.keys(controls);
    for(var x=0; x<chaves.length; x++){
        var atual=chaves[x];
        if(!values.hasOwnProperty(atual)){ continue;}
        controls[atual].reset({value:values[atual], disabled:this.isLockForm()});
    }
    return this;
  }

   protected modelPopulate(values):InstiComponent{
       var model_instance=this.getModel();
       var chaves=!model_instance? [] : Object.keys(model_instance);
       for(var x=0; x<chaves.length; x++){
            var atual=chaves[x];
            if(!values.hasOwnProperty(atual)){continue; }
           model_instance[atual]=values[atual];
       }
       this.model=model_instance;
       return this;
   }

   protected formClean():InstiComponent{
    var form=this.getForm();
    var controls=form.controls;
    var chaves=Object.keys(controls);
    for(var x=0; x<chaves.length; x++){
        var atual=chaves[x];
        controls[atual].reset({value:'', disabled:this.isLockForm()});
    }
    return this;
   }


   onEditConfirm(event) {
    // if (!window.confirm('Deseja salvar as alterações?')) {
    //   event.confirm.reject();
    //   return null;
    // }
    let instance = this;
    var form_data=this.getFormValues();
    instance.setIsLoading(true);
    this.getService().editar(form_data,
        function(response){
          instance.setIsLoading(false);
          instance.showAlert('Sucesso', response['msg'], 'success');
          instance.formClean();
          instance.goBackSmsg();
            // window.alert('Dados alterados com sucesso!');
        },
        function(error){
          instance.setIsLoading(false);
            // event.confirm.reject();
            instance.showAlert('Erro', error.error.msg, 'error');
            // window.alert('Deu erro. COD: 110920191112');
        });
  }
  onDeleteConfirm(event): void {
    let instance = this;
    var form_data=this.getFormValues();

    instance.showAlert("Atenção!","Os dados cadastrados serão perdidos. Deseja continuar?","warning",true,(res)=>{
      if(res.value){
        instance.setIsLoading(true);
        this.getService().deletar(form_data,
        function(response){
          instance.setIsLoading(false);
          // instance.goBack();
          instance.showAlert('Sucesso', response['msg'], 'success');
          instance.goBackSmsg();
        },
        function(error){
          instance.setIsLoading(false);
          instance.showAlert('Erro', error.error.msg, 'error');
            // event.confirm.reject();
          //   window.alert('Deu erro. COD: 110920191112');
        });

      }
    }, "Sim", "Não");


    }
    protected showAlert(titulo, mensagem, tipo, showCancel=false,call_back?, confirmText:any = 'OK', cancelText:any = 'Cancelar', width = '32rem'){
      this.getService().showAlert(titulo, mensagem, tipo,showCancel,call_back,confirmText, cancelText, width);
    }

    protected goBack(){

      if(this.form != undefined && !this.form.pristine){
        this.showAlert('Atenção!','Os dados digitados serão perdidos. Deseja continuar?','warning',true,(res)=>{
          if(res.value){
            this.location.back();
          }
        }, "Sim", "Não");

      }
      else{
        this.location.back();
      }
    }
    protected goBackSmsg(){
      this.location.back()
    }


    /**
     * Aluisio Ferreira de Sousa. 25/10/2019
     * @param HTMLNODE row_element Html Node with childrens( Html Collection)
     * @param ARRAY keys_name Array of String
     * @param OBJECT process_cell OPTIONAL Object with keys equivalent like keys_name with
     *  function to process content of element
     */
   extractDataFromRowHtmlTable(row_element, keys_name: string[], process_cell?){
       let childrens=row_element.children;
       var chaves=keys_name;
       let retorno:any={};
       /**
        * Checar a necessidade de verificar se a quantidade de chaves é igual a
        * quantidade de elementos filhos.
        *
       if(row_element.chilElementCount!= keys_name.length){

       }
       */

       var x=0;
       for(x=0; x<childrens.length; x++){
           var atual=x;
          var chave=chaves.hasOwnProperty(atual)? chaves[atual] : atual;
          var content=(!process_cell? {} : process_cell).hasOwnProperty(chave) ? process_cell[chave](childrens[atual].textContent.trim()) : childrens[atual].textContent.trim();
          retorno[chave]=content;
       }
       return retorno;
   }
   serviceMethodRun(method_name, params?){
       let service_instance = this.getService();

       if(!params){
        return service_instance[method_name]();
       }
       if(!params.length){
        return service_instance[method_name]();
       }
       return service_instance[method_name].apply(this, Array.prototype.slice.call(params, 1));
   }
   beForEach(values){
    let value;
     for (value of values) {
       value['id']=value['id'].toString();
     }
     return values;
  }

   isParent(p_instance?, p_name_class?){
       let l_instance=!p_instance ? this: p_instance;
       let l_name_class=!p_name_class? this.constructor.name : p_name_class;
       return l_instance.constructor.name === l_name_class;
   }

   filterArray(array_data,array_op,field_data){
        let filter_e_o = array_op.map(event =>{
            return event.id.toString();
        });

        let filter_a_i = array_data.map(a =>{
            return a.data[field_data];
        });

        let apenasNoR1 = filter_e_o.filter(function (element, index, array) {
            if(filter_a_i.indexOf(element) == -1)
                return element;
        });
        let a = new Array();
        for (let i = 0; i < apenasNoR1.length; i++) {

            a[i] = array_op.filter(op=>{
                return op.id == apenasNoR1[i];
            })[0];

        }

      return a;
   }
  validarCNPJ(cnpj) {

    cnpj = cnpj.replace(/[^\d]+/g,'');

    if(cnpj == '') return false;

    if (cnpj.length != 14)
        return false;

    // Elimina CNPJs invalidos conhecidos
    if (cnpj == "00000000000000" ||
        cnpj == "11111111111111" ||
        cnpj == "22222222222222" ||
        cnpj == "33333333333333" ||
        cnpj == "44444444444444" ||
        cnpj == "55555555555555" ||
        cnpj == "66666666666666" ||
        cnpj == "77777777777777" ||
        cnpj == "88888888888888" ||
        cnpj == "99999999999999")
        return false;

    // Valida DVs
    let tamanho = cnpj.length - 2
    let numeros = cnpj.substring(0,tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
            pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0))
        return false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0,tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
            pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1))
          return false;

    return true;

}

   validaSalarios(dados){
    var meses=[
      parseFloat(dados['jan_orcado']), parseFloat(dados['fev_orcado']), parseFloat(dados['mar_orcado']), parseFloat(dados['abr_orcado']),
      parseFloat(dados['mai_orcado']), parseFloat(dados['jun_orcado']), parseFloat(dados['jul_orcado']), parseFloat(dados['ago_orcado']),
      parseFloat(dados['set_orcado']), parseFloat(dados['out_orcado']), parseFloat(dados['nov_orcado']), parseFloat(dados['dez_orcado'])
    ];
    var atual=1;
    var anterior=0;
    var conta=0;
    var conta_else=0;
    for(atual=1;atual<meses.length;atual++){
      anterior=atual-1;
      if(meses[atual]<meses[anterior]){
        conta++;
      }else{
        conta_else++;
      }
    }
    if(conta==0){
      return true;
    }
    else{
      return false;
    }
  }
  initLoadObj(){
    this.loadObj=new instiLoading();
    return this.loadObj;
  }
  getIsLoading(){
    let a=(!this.loadObj? this.initLoadObj() :  this.loadObj).getIsLoading();
    // console.log("loading", a)
    return a;
  }
  setIsLoading(value: boolean){
    this.is_loading.emit((!this.loadObj? this.initLoadObj() :  this.loadObj).setIsLoading(value).getIsLoading());
    return this;
  }
  setPermissoes(values){

    this.permissoes_dados = JSON.parse(localStorage.getItem('dados_tags'));
  }
  getFilterPermissoes(tag:string, descricao:string){
    //console.log(tag, descricao);
    if(!tag){
      return this;
    }
    tag = tag.toUpperCase();
    descricao = descricao.toUpperCase();

    let dados = JSON.parse(localStorage.getItem('dados_tags'));

    if(!dados){
      return false;
    }

    let cont=0, i;
    for(i = 0; i < dados.length; i++){
      if(dados[i]['cod'] == tag && dados[i]['descricao'] == descricao)
      {
        cont++;
        break;
      }
    }
    //console.log("cont",cont,i,'descricao: ',descricao,'tag: ',tag);

    if(cont==1){
      return true;
    }
    else{
      return false;
    }
  }

  getFilterPermissoesMenu(tag_id, tela_id){

    // if(tela_id == 3){
    //   alert("entrou" + tag_id);
    // }
    let dados = JSON.parse(localStorage.getItem('dados_tags'));

    let cont=0, i;
    for(i = 0; i < dados.length; i++){
      if(dados[i]['id_tag'] == tag_id && dados[i]['id_tela'] == tela_id)
      {
        // cont++;
        // break;
        return true;
      }
    }
    //console.log("cont",cont,i,'descricao: ',tela_id,'tag: ',tag_id);

    // if(cont==1){
    //   return true;
    // }
    // else{
    //   return false;
    // }
    return false;
  }
  goToLugarAndMsg(cod_tela,descricao,link_url){

    if(!this.getFilterPermissoes(cod_tela, descricao)){

      setTimeout(() => {
        this.setIsLoading(false);
      }, 100);
      this.setAddLink('/natureza51/'+link_url);
      var url =  this.getAddLink();
      var dados={modo: this.getPageModeAdd()};
      this.insti_route.getRoutObj().navigate([url])
      this.showAlert('Atenção!','Seu perfil não tem permissão para acessar esta tela.','warning');
    }
  }

  //Exportação Excel
  getBaseUrlExport(){
    return this.service.getUrlExport();
  }
  public getArrayImprimir(){ return this.array_imprimir; }

  protected setArrayImprimir(value):InstiComponent{
    this.array_imprimir=value;
    return this;
  }
  exportData(){
    let instance = this;
   this.getTableSourcedata().getFilteredAndSorted().then((data)=>{
     if(data.length > 0){
       instance.setIsLoading(true);
       instance.setArrayImprimir(JSON.stringify(data));
       setTimeout(function (){
         instance.setIsLoading(false);
         var botaoSubmit = document.getElementById("btnSubmit")
         botaoSubmit.click();
         var formDownload = document.getElementById("formDownload");
         let metodo = 'submit';
         formDownload[metodo]();
       }, 2000);
     }
     else{
       instance.showAlert("Atenção", "Não existem dados para exportar.", 'warning');
     }

   })
 }

  getItemToken(){
    this.token = localStorage.getItem('insti_authorization');
  }
    getUrlExport(){
      return (this.url_export=='')? this.page_title:this.url_export;
  }
    setUrlExport(value){
    this.url_export = value;
      return this;
  }
  setShowExportButton(v){
    this.showExportButton = v;
    return this;
  }
  getShowExportButton(){
    return this.showExportButton;
  }
  permissaoExcluir(){

    if((!this.getCargosUrl()) && (this.isPageMode(this.getPageModeDel())) ){
      this.showAlert("Atenção","Impossível executar operação solicitada! <br>Registro proveniente do ERP.","warning");
      this.btn_esconder = false;
    }else{
      this.btn_esconder = true;
    }
  }
  getCargosUrl(){
    let dados = this.insti_route.getParams();
    if(dados['origem'] == 0){
      return false;
    }else{
      return true;
    }
  }

  isUserTecnico(){
    let user = this.getService().getUserData();
    if(!user){
      return false;
    }
    return user.tipo_user == 3;
  }
  getDescListar(){
    return 'listar';
  }
  getDescExp(){
    return 'exportar';
  }
  getDescAtualizar(){
    return 'atualizar';
  }
  getDescEditar(){
    return 'editar';
  }
  getDescInserir(){
    return 'inserir';
  }
  getDescDeletar(){
    return 'deletar';
  }
  getDescImportar(){
    return 'importar';
  }
  camposControle(colunas:any[], columns_put:any[], columns_remove:any[], checked:boolean){
    if(checked == true){
      for(let i = 0; i < columns_put.length; i++){
        colunas.push(columns_put[i]);
      }
    }
    else{
      for(let i = 0; i < columns_remove.length; i++){
        let index = colunas.indexOf(columns_remove[i]);
        colunas.splice(index, 1);
      }
    }
  }

  formataToExport(dado:string){

    if (typeof (dado) == 'string' && dado.indexOf('.') != -1) {
      // se encontrar '.', irá retirar todos
      let valor = dado.replace('.', '');
      if (valor.indexOf(',') != -1) {
        // se encontrar ',', irá substituir por '.'
        return parseFloat(valor.replace(',', '.'));
      }
      else{
      	return parseFloat(valor);
      }
    }
    else if (typeof (dado) == 'string' && dado.indexOf('.') == -1) {
      // se não encontrou '.'
      if (dado.indexOf(',') != -1) {
        // se encontrar ',', irá substituir por '.'
        return parseFloat(dado.replace(',', '.'));
      }
      return parseFloat(dado);
    }
    else {
      return dado;//parseFloat( dado );
    }
  }
  voltarFormatacao(dado){
    if(dado != 0){
      return new Intl.NumberFormat('de-DE').format(dado);
    }
    return 0
  }
  /**
   * Matheus Lopes Correia 25/03/2021
   * @param orc_id orcamento
   * @param ano ano
   * @param tipo F, O ou R
   * @param periodo periodo no formato: '2020-01-01'
   * @returns Informativo para a exportação
   */
  getDescRelatorio(orc_id, ano, tipo:string, periodo?:string){
    let complemento = '';

    if(tipo == 'F'){
      complemento = `Forecast ${periodo.substr(5, 2)}/${ano}`;
    }
    else if(tipo == 'O'){
      complemento = `Orçado ${ano}`;
    }
    else{
      complemento = `Realizado ${ano}`;
    }


    let data_objeto = new Date();
    let date = data_objeto.getDate()+'/'+data_objeto.getMonth()+'/'+data_objeto.getFullYear()+' '+data_objeto.getHours()+':'+data_objeto.getMinutes();
    let desc = orc_id+' - '+complemento+`. Gerado por ${this.getService().getUserData()['nome']}, em `+date;

    return desc;
  }
}


export class Anexo {
  id:number;
  descricao:string;
  base64:string;
  nome:string;
  documento?: number;
  tipo_anexo?: number;
}
